function r(t) {
  const n = Math.random().toString();
  return `${t ? `${t}-` : ""}${n.substring(2)}`;
}
export {
  r as default
};
